<template>
  <span :class="`badge badge-${statuses[status]?.status}`">{{ statuses[status]?.title}}</span>
</template>

<script>

export default {
  props: ['status'],
  data() {
    return {
      statuses: {
        0: {status: 'primary', title: 'С сайта'},
        9999: {status: 'success', title: 'Ручная'},
        1: {status: 'info', title: 'Обработана'},
        2: {status: 'info', title: 'Назначена'},
        3: {status: 'success', title: 'Закрыта'},
        5: {status: 'success', title: 'Доставлена агентом'},
        8: {status: 'info', title: 'Спрос'},
        9: {status: 'info', title: 'Предварительная'},
        11: {status: 'success', title: 'Доставлена'},
        4: {status: 'info', title: 'Сгруппирована'},
        '-2': {status: 'warning', title: 'Отказ у менеджера'},
        '-3': {status: 'warning', title: 'Отказ у курьера'},
        '10000': {status: 'info', title: 'Архив'},
        '10001': {status: 'info', title: 'Архив'}
      }
    }
  }
}

</script>
